import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

export enum ProviderMessageStatus {
  Delayed = 2,
  Read = 3
}

export type ProviderMessage = {
  status: number;
  title: string;
  message: string;
};

@Injectable({ providedIn: 'root' })
export class ProviderMessageService {
  private http = inject(HttpClient);

  private baseUrl = '/api/provider-message';

  getMessage(): Observable<ProviderMessage> {
    return this.http.get<ProviderMessage>(this.baseUrl);
  }

  updateStatus(status: ProviderMessageStatus, delayHours = 24): Observable<void> {
    return this.http.put<void>(this.baseUrl, null, { params: { status, delayHours } });
  }
}
